import { configureStore } from '@reduxjs/toolkit';
// import slideReducer from '../features/Main/Experiences/function';
import cradToggleReducer from '../features/Main/FAQs/function';
// import strpperReducer from '../features/Main/Guidelines/function';

export const store = configureStore({
  reducer: {
    //VerticalSlider: slideReducer,
    FaqCard: cradToggleReducer,
    //GuidelineStep: strpperReducer
  },
});
